import React, { useEffect, useState } from "react";
import Header from "../../common/Header/Header";
import Sidebar from "../../common/Sidebar/Sidebar";
import action from "../../asessts/Images/arrow_left.svg";
import TrackIcon from "../../asessts/Images/track_right_icon.svg";
import Api from "../../services/Api";
import { useParams } from "react-router-dom";
import Loading from "../../common/Loading/Loading";

function TrackOrderDetails() {
  const { id } = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const [orderDetails, setOrderDetails] = useState([]);
  const [dispatchedPhotos, setDispatchedPhotos] = useState([]);
  const [userDetails, setUserDetails] = useState({});
  const [orderNumber, setOrderNumber] = useState("");
  const [trackNumber, setTrackNumber] = useState("");
  const [trackingUrl, setTrackingUrl] = useState("");
  const [extraDetails, setExtraDetails] = useState({});
  // console.log("userDe=======", userDetails);

  const formatStatus = (status) => {
    return status
      ? status
          .split("-")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" ")
      : "";
  };

  const fetchOrderDetails = async () => {
    try {
      setIsLoading(true);
      const response = await Api.get_track_order(id);
      const trackOrderListing = response?.data?.response || [];
      setOrderDetails(trackOrderListing);
      setUserDetails(response?.data?.UserDetail || {});
      setOrderNumber(response?.data?.orderId || "");
      setExtraDetails({
        dressName: response?.data?.DressInfo?.dressName || "",
        rentalPrice: response?.data?.rentalPrice || "",
        postagePrice: response?.data?.postagePrice || "",
        status: response?.data?.trackStatus || "",
        createdDate: response?.data?.createdDate || "",
        completedDate: response?.data?.completedDate || "",
        orderFrom: response?.data?.orderDates?.from || "",
        orderTo: response?.data?.orderDates?.to || "",
      });

      const lastItem = trackOrderListing[trackOrderListing.length - 1];
      const status = lastItem?.status;

      switch (status) {
        case "dispached-by-lender":
          setDispatchedPhotos(
            lastItem?.dispatchedByLenderDetail?.dispatchPhotos || []
          );
          // setOrderNumber(lastItem?.dispatchedByLenderDetail?.orderId);
          setTrackingUrl(lastItem?.dispatchedByLenderDetail?.trackUrl);
          setTrackNumber(lastItem?.dispatchedByLenderDetail?.trackNumber);
          break;
        case "received-by-borrower":
          setDispatchedPhotos(
            lastItem?.recievedByBorrowerDetail?.receivedOrderPhotos || []
          );
          // setOrderNumber(lastItem?.recievedByBorrowerDetail?.orderId);
          setTrackingUrl(lastItem?.recievedByBorrowerDetail?.trackUrl);
          setTrackNumber(lastItem?.recievedByBorrowerDetail?.trackNumber);
          break;
        case "In Transit":
          setDispatchedPhotos(
            lastItem?.intransiteByLender?.intransiteImages || []
          );
          // setOrderNumber(lastItem?.intransiteByLender?.orderId);
          setTrackingUrl(lastItem?.intransiteByLender?.trackUrl);
          setTrackNumber(lastItem?.intransiteByLender?.trackNumber);
          break;
        case "return-by-borrower":
          setDispatchedPhotos(
            lastItem?.returnBackByBorrower?.returnBackPhotos || []
          );
          // setOrderNumber(lastItem?.returnBackByBorrower?.orderId);
          setTrackingUrl(lastItem?.returnBackByBorrower?.trackUrl);
          setTrackNumber(lastItem?.returnBackByBorrower?.trackNumber);
          break;
        // case "accepted-by-lender":
        //   setDispatchedPhotos(
        //     lastItem?.disputeByLenderDetail?.disputedPhotos || []
        //   );
        //   setOrderNumber(lastItem?.disputeByLenderDetail?.orderId);
        //   setTrackingUrl(lastItem?.disputeByLenderDetail?.trackUrl);
        //   setTrackNumber(lastItem?.disputeByLenderDetail?.trackNumber);
        //   setResponseMessage(
        //     lastItem?.dispatchedByLenderDetail?.reasonOfDispute
        //   );
        // break;
        default:
          setDispatchedPhotos([]);
          break;
      }

      setIsLoading(false);
    } catch (error) {
      console.error("Error fetching order details:", error);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchOrderDetails();
  }, [id]);

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    const options = {
      day: "2-digit",
      month: "short",
      year: "numeric",
    };
    return date.toLocaleDateString("en-US", options);
  };

  return (
    <div className="admin-dashboard">
      <Sidebar />
      <div className="main-dashboard subadmin-dashboard">
        <Header imageUrl={action} title={`Order details`} />
        <div className="loaction-list-main order-list-main">
          {isLoading ? (
            <Loading />
          ) : (
            <div className="order-tracking-main item-details-main">
              <div className="tracking-left">
                <div className="head">
                  <h3>Order Tracking Details</h3>
                </div>
                <div className="details">
                  <div className="input-group">
                    {orderNumber && (
                      <div className="input-field">
                        <label>Order ID</label>
                        <input type="text" value={orderNumber} readOnly />
                      </div>
                    )}
                    <div className="input-field">
                      <label>Order Dates</label>
                      <input
                        type="text"
                        value={`${formatDate(
                          extraDetails.orderFrom
                        )} - ${formatDate(extraDetails.orderTo)}`}
                        readOnly
                      />
                    </div>
                    <div className="input-field">
                      <label>Item Title</label>
                      <input
                        type="text"
                        value={extraDetails.dressName}
                        readOnly
                      />
                    </div>
                    <div className="input-field">
                      <label>Lender Name</label>
                      <input
                        type="text"
                        value={userDetails?.lenderName}
                        readOnly
                      />
                    </div>
                    <div className="input-field">
                      <label>Lender Email</label>
                      <input
                        type="text"
                        value={userDetails?.lenderEmail}
                        readOnly
                      />
                    </div>
                    <div className="input-field">
                      <label>Borrower Name</label>
                      <input
                        type="text"
                        value={userDetails?.borrowerName}
                        readOnly
                      />
                    </div>
                    <div className="input-field">
                      <label>Borrower Email</label>
                      <input
                        type="text"
                        value={userDetails?.borrowerEmail}
                        readOnly
                      />
                    </div>
                    <div className="input-field">
                      <label>Rental Price</label>
                      <input
                        type="text"
                        value={
                          extraDetails.rentalPrice
                            ? `€${extraDetails.rentalPrice}`
                            : ""
                        }
                        readOnly
                      />
                    </div>

                    <div className="input-field">
                      <label>Postage Price</label>
                      <input
                        type="text"
                        value={
                          extraDetails.postagePrice
                            ? `€${extraDetails.postagePrice}`
                            : ""
                        }
                        readOnly
                      />
                    </div>
                    <div className="input-field">
                      <label>Status</label>
                      <input
                        type="text"
                        value={formatStatus(extraDetails.status)}
                        readOnly
                      />
                    </div>
                    <div className="input-field">
                      <label>Created Date</label>
                      <input
                        type="text"
                        value={formatDate(extraDetails.createdDate)}
                        readOnly
                      />
                    </div>

                    {trackNumber && (
                      <div className="input-field">
                        <label>Tracking Number</label>
                        <input type="text" value={trackNumber} readOnly />
                      </div>
                    )}
                    {trackingUrl && (
                      <div className="input-field">
                        <label>Tracking URL</label>
                        <input type="text" value={trackingUrl} readOnly />
                      </div>
                    )}
                  </div>
                  {dispatchedPhotos.length > 0 && (
                    <div className="order-photos">
                      <label>Product Dispatched Photos</label>
                      <div className="img">
                        {dispatchedPhotos.map((photo, index) => (
                          <span key={index}>
                            <img
                              className="py-3"
                              src={photo}
                              alt={`Dispatched ${index}`}
                            />
                          </span>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              </div>
              {orderDetails.length !== 0 && (
                <div class="tracking-right">
                  <h3>Order Tracking Details</h3>
                  <div class="return-back">
                    <div class="head">
                      <h4>
                        {orderDetails.length > 0
                          ? formatStatus(
                              orderDetails[orderDetails.length - 1].status
                            )
                          : ""}
                      </h4>
                    </div>
                    <div class="track-path">
                      <div class="order-track-path">
                        {orderDetails.map((order, index) => (
                          <div className="key-chain" key={index}>
                            <div className="key-chain-img">
                              <span>
                                <img src={TrackIcon} alt="" />
                              </span>
                            </div>
                            <div className="key-chain-head">
                              <h3>{formatStatus(order.status)}</h3>
                              <p>{formatDate(order.createdAt)}</p>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
export default TrackOrderDetails;
